export default {
      id: "icon-strap-usage",
      viewBox: "0 0 37.552 37.55",
      url: __webpack_public_path__ + "icons.svg#icon-strap",
      toString: function () {
        return this.url;
      }
    }